module.exports = __webpack_public_path__ + "img/Icon-monFAD.03eb75a9.svg";